import { useMemo } from 'react'

import { PlanType } from '$extensionSrc/__generated__/graphql'
import { dayInMs } from '$extensionSrc/utils/dateUtils'
import { PLATFORM } from '$extensionSrc/utils/enums'

import { User } from './user'

export type UseTrialRv = {
  daysRemaining: {
    numeric: number
    text: string
  }
  platform: PLATFORM
}

export function useTrial(user: User): UseTrialRv | null | undefined {
  return useMemo(() => {
    if (user === undefined) {
      return undefined
    }

    if (user === null) {
      return null
    }

    if (
      !user.trialPlatform ||
      !user.trialExpiresOn ||
      user.planType !== PlanType.TrialPlan
    ) {
      return null
    }

    const nowTimestamp = Date.now()
    const expiresOnTimestamp = new Date(user.trialExpiresOn).valueOf()
    const msRemaining = expiresOnTimestamp - nowTimestamp
    if (Number.isNaN(msRemaining) || msRemaining <= 0) {
      return null
    }
    const numeric = Math.ceil(msRemaining / dayInMs)

    const text = `${numeric} day${numeric !== 1 ? 's' : ''} left`

    return {
      daysRemaining: {
        numeric,
        text,
      },
      platform: user.trialPlatform,
    }
  }, [user])
}
